import { render, staticRenderFns } from "./2.vue?vue&type=template&id=1de5bf93&scoped=true&"
var script = {}
import style0 from "./2.vue?vue&type=style&index=0&id=1de5bf93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5bf93",
  null
  
)

export default component.exports